export default {"src":"/evde-internet/_next/static/media/red-document.8d89ebcb.svg","height":36,"width":36};